import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStarshipComponent } from './simple-icons-starship.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStarshipComponent ],
    exports:      [ SimpleIconsStarshipComponent ],
    bootstrap:    []
})
export class SimpleIconsStarshipModule {}
